import usePostList from "../../hooks/usePostList";
import { resolveAssetUrl } from "../../services/apiConfig";
import styles from "../profile/Profile.module.css";
import { AuthContext } from "../../context/AuthContext";
import { getPosts } from "../../services/postService";
import { useContext, useState } from "react";
import { PostModal } from "../../components/modal/PostModal";
import Loader from "../../components/Loader/Loader";

function Explore({ refreshVersion = 0 }) {

  const { user } = useContext(AuthContext);
  const { posts, isLoading } = usePostList(getPosts, refreshVersion);



  const [isPostModalVisible, setIsPostModalVisible] = useState(false);
  const [selectedPost, setSelectedPost] = useState(null);

  const handlePostModal = (value, post = null) => {
    setSelectedPost(post);
    setIsPostModalVisible(value);
  };

  return (
    user &&
    (isLoading ? (
      <Loader />
    ) : (
      <div className={styles.userPost}>
        {posts.length > 0 ? (
          posts.map((post) => (
            <div className={styles.imageContainer} key={post.id}>
              <img
                src={resolveAssetUrl(post.image_url)}
                alt={post.id}
                onClick={() => handlePostModal(true, post)}
              />
            </div>
          ))
        ) : (
          <p className={styles.noPost}>Nenhuma publicação para exibir</p>
        )}
        {selectedPost && (
          <PostModal
            isVisible={isPostModalVisible}
            handleModal={setIsPostModalVisible}
            post={selectedPost}
          />
        )}
      </div>
    ))
  );
}

export default Explore;
